module.exports = __webpack_public_path__ + "static/coregx-0b47b57a2daba5cf7597b7563d3ed005.png";